import React, { Children, cloneElement, forwardRef } from 'react';
import styled, { css } from 'styled-components';

import { IconButton } from 'shell/components';

const SideDrawerContainer = styled.div`
    width: ${(props) => (props.width ? props.width : '365px')};
    height: ${(props) => props.height};
    position: fixed;
    top: ${(props) => (props.headerShown ? '64px' : '0px')};
    z-index: ${(props) => props.zIndex};

    ${(props) =>
        props.left
            ? css`
                  left: 0;
              `
            : css`
                  right: 0;
              `}

    visibility: hidden;

    background-color: white;
    box-shadow: ${(props) =>
        props.device === 'mobile' ? 'none' : '0 2px 20px rgba(0, 0, 0, 0.12), 0 3px 5px rgba(0, 0, 0, 0.16)'};
    overflow-x: hidden;
    overflow-y: auto;

    transform: ${(props) => (props.left ? 'translateX(-' + props.width + ')' : 'translateX(' + props.width + ')')};
    transition: all 0.2s ease-out;

    ${(props) =>
        props.open &&
        css`
            visibility: visible;
            transform: translateX(0);
        `}
`;

const SideDrawer = forwardRef(
    (
        {
            style,
            open,
            left = true,
            width = '365px',
            height = 'calc(100vh - 64px)',
            headerShown = false,
            device = 'desktop',
            children,
            zIndex = 1,
            closable = false,
            onCancel,
            ...rest
        },
        ref
    ) => {
        return (
            <SideDrawerContainer
                ref={ref}
                open={open}
                left={left}
                width={width}
                height={height}
                device={device}
                headerShown={headerShown}
                zIndex={zIndex}
                {...rest}
            >
                {closable ? <IconButton kind={'exit'} onClick={onCancel} /> : <></>}
                {Children.map(children, (child) => cloneElement(child, { hidden: !Boolean(open) }))}
            </SideDrawerContainer>
        );
    }
);

export default SideDrawer;
